import { BrowserCacheLocation, InteractionType } from '@azure/msal-browser';
import { LogLevel } from '@azure/msal-common';

export const environment = {
  production: true,
  name: 'prod',
  skipDynamicEnvironment: false,
  isStation: true,
  apis: {
    appInsights: {
      instrumentationKey: '8c08bf39-935d-46fa-9661-87b3f9a63465', // appinsightsprod-nim-client-station
    },
    azure: {
      correlationTokenName: 'abc-correlation-token',
      subscriptionKeyHeaderName: 'Ocp-Apim-Subscription-Key',
      subscriptionKey: 'c0c75177933a4bd4b5b3c80a03ae7b47',
    },
    diagnosisCode: {
      endpointUrl: '',
      subscriptionKeyHeaderName: 'Ocp-Apim-Subscription-Key',
      subscriptionKey: '0b221df0e27f460f89739826bef9b33c',
    },
    entitlements: {},
    emrintegration: {},
    formulary: {},
    identity: {},
    inventory: {},
    lookup: {},
    party: {},
    purchaseorder: {},
    patient: {},
    physician: {},
    stationmanagement: {},
    printing: {
      endpointUrl: 'https://services.hdp.amerisourcebergen.com/Printing',
    },
    configuration: {
      endpointUrl: 'https://services.hdp.amerisourcebergen.com/configuration',
    },
    pricing: {
      endpointUrl: 'https://services.hdp.amerisourcebergen.com/Pricing',
    },
  },
  useStateManagement: false,
  useApiPrinting: false,
  msalConfig: {
    interactionType: InteractionType.Popup,
    auth: {
      clientId: 'f2b9bd52-0088-4df5-8d2c-1ea3633fd362',
      navigateToLoginRequestUrl: false,
      redirectUri: '/auth',
      postLogoutRedirectUri: '/',
    },
    cache: {
      cacheLocation: BrowserCacheLocation.SessionStorage,
      storeAuthStateInCookie: false,
    },
    system: {
      loggingOptions: {
        logLevel: LogLevel.Error,
        piiLoggingEnabled: false,
      },
    },
  },
  apiConfig: {
    scopes: ['f2b9bd52-0088-4df5-8d2c-1ea3633fd362'],
    uri: 'https://services.hdp.amerisourcebergen.com',
    anonymousEndpoints: [],
  },
  b2cPolicies: {
    names: {
      signUpSignIn: 'B2C_1A_local_signin',
      resetPassword: 'B2C_1A_local_signin',
      editProfile: 'B2C_1A_local_signin',
    },
    authorities: {
      signUpSignIn: {
        authority: 'https://SPSCustomer.b2clogin.com/SPSCustomer.onmicrosoft.com/B2C_1A_local_signin',
      },
      resetPassword: {
        authority: 'https://SPSCustomer.b2clogin.com/SPSCustomer.onmicrosoft.com/B2C_1A_local_signin',
      },
      editProfile: {
        authority: 'https://SPSCustomer.b2clogin.com/SPSCustomer.onmicrosoft.com/B2C_1A_local_signin',
      },
    },
    authorityDomain: 'SPSCustomer.b2clogin.com',
  },
  cmsUrl: 'https://cms.nucleusinventory.com/cms/production/stationmvp/',
};
